import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api.js';

export interface Organisateur {
  id: string;
  email: string;
  nom: string | null;
}

/** Charge l'organisateur connecté ; redirige vers /connexion si la session est absente. */
export function useOrganisateur(): Organisateur | null {
  const [organisateur, setOrganisateur] = useState<Organisateur | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    let actif = true;
    api
      .get<{ organizer: Organisateur }>('/api/auth/me')
      .then((r) => actif && setOrganisateur(r.organizer))
      .catch(() => actif && navigate('/connexion', { replace: true }));
    return () => {
      actif = false;
    };
  }, [navigate]);
  return organisateur;
}
